/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'GoalLinker.error.generic.description': '接続を確認してもう一度お試しください。',
  'GoalLinker.error.generic.header': '問題が発生しました',
  'GoalLinker.error.linking.header': 'ゴールをリンクできませんでした',
  'GoalLinker.error.max-entities-to-goal.description':
    'ゴールにリンクできる {entities} は最大 100 件です。追加の {entities} をリンクするには、{entity} を削除してください。',
  'GoalLinker.error.max-entities-to-goal.header': '{entity} の上限 (100) に達しました',
  'GoalLinker.error.max-goals.description':
    '最大 100 件のゴールをリンクすることができます。追加のゴールをリンクする場合は、現在リンク済みのゴールをいくつか削除してください。',
  'GoalLinker.error.max-goals.header': 'ゴールの上限 (100) に達しました',
  'GoalLinker.goal-row.open-goal': 'ゴールを開く',
  'GoalLinker.link-goals.error-description': '問題が発生しました。インターネット接続を確認してもう一度お試しください。',
  'GoalLinker.link-goals.error-title': 'ゴールのリンクを解除できませんでした',
  'GoalLinker.linked-goals.header': 'リンク済みのゴール',
  'GoalLinker.linked-goals.show-less': '表示を減らす',
  'GoalLinker.linked-goals.show-more': '他 {count} 件を表示',
  'GoalLinker.recents.emptystate-jira-product-discovery.description':
    'アイデアをゴールにリンクし、作業がどのように成果に貢献するかを追跡します',
  'GoalLinker.recents.emptystate-project.description':
    'プロジェクトをゴールにリンクし、作業がどのように成果につながるかを追跡します',
  'GoalLinker.recents.emptystate.description':
    '作業項目をゴールにリンクし、作業がどのように成果につながるかを追跡します',
  'GoalLinker.recents.emptystate.header': 'ゴールの使用を開始する',
  'GoalLinker.recents.header': '最近のゴール',
  'GoalLinker.search.emptystate.description': '誤字がないかを確認してください',
  'GoalLinker.search.emptystate.header': '一致する結果がありません',
  'GoalLinker.search.label': '検索結果',
  'GoalLinker.search.placeholder': 'ゴールを検索するか、リンクを貼り付け',
};
